import { render, staticRenderFns } from "./genre-pills.vue?vue&type=template&id=9e4ad5e4&scoped=true"
import script from "./genre-pills.vue?vue&type=script&setup=true&lang=js"
export * from "./genre-pills.vue?vue&type=script&setup=true&lang=js"
import style0 from "./genre-pills.vue?vue&type=style&index=0&id=9e4ad5e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4ad5e4",
  null
  
)

export default component.exports